import { useDispatch, useSelector } from 'react-redux';
import { selectAppTheme } from 'src/store/selectors/appConfigSelectors';
import { setAppTheme } from 'src/store/actions/appConfigActions';
const useThemeSwitch = () => {
    const dispatch = useDispatch();
    const theme = useSelector(selectAppTheme);
    const changeTheme = (themeType) => {
        dispatch(setAppTheme(themeType));
    };
    return [theme, changeTheme];
};
export default useThemeSwitch;
